import { render, staticRenderFns } from "./Applica.vue?vue&type=template&id=6a1b6204&scoped=true&"
import script from "./Applica.vue?vue&type=script&lang=js&"
export * from "./Applica.vue?vue&type=script&lang=js&"
import style0 from "./Applica.vue?vue&type=style&index=0&id=6a1b6204&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1b6204",
  null
  
)

export default component.exports